import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "projects" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "menu"
}
const _hoisted_5 = { class: "message" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_back_button = _resolveComponent("back-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Nav),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_back_button),
      (_ctx.organization)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.organization.name) + " Profiles", 1))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, "Profiles")),
      (_ctx.organization  && _ctx.currentAccount.role >= _ctx.AccountRole.ORGANIZATION_ADMIN)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: { name: 'Organization', org_slug: _ctx.organization.slug }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "edit" }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "編集", -1))
              ]),
              _: 1,
              __: [1]
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Table, {
        data: _ctx.data,
        headers: _ctx.headers,
        linkCols: _ctx.linkCols,
        newUri: _ctx.newUri,
        newCaption: _ctx.newCaption
      }, null, 8, ["data", "headers", "linkCols", "newUri", "newCaption"])
    ]),
    _createVNode(_component_Dialog, {
      ref: "error",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "title" }, "Error", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.error.message), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.errorClose && _ctx.errorClose(...args)))
          }, "Close")
        ])
      ]),
      _: 1,
      __: [2]
    }, 512)
  ], 64))
}